import { getRequest } from '../services/requestHandler';
import { LoftFraction } from '../models';
//6 for testing
export const getLoftFractions = async (headTypeId = null) => {
  const url = headTypeId ? `loft/getLoftFractions?headTypeId=${headTypeId}` : 'loft/getLoftFractions';
  const response = await getRequest<LoftFraction>('GetLoftFractions', url);
  return response;
};
